import _defineProperty from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _taggedTemplateLiteral from "/vercel/path0/apps/corona/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _excluded = ["data"],
    _excluded2 = ["data"];

var _templateObject, _templateObject2, _templateObject3;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import * as R from 'ramda';
import { useMemo } from 'react';
import { BranchConstants } from 'src/constants';
import { RoleType } from 'src/types';
export var UsersByIDsQuery = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  query UsersByIDsQuery($userIDs: [Int!]) {\n    users(where: { id: { _in: $userIDs } }) {\n      id\n      last_name\n      first_name\n      nick_name\n    }\n  }\n"])));
export var UsersWithRoleQuery = gql(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  query UsersWithRoleQuery($branch_id: bigint, $role: String) {\n    roles(where: { name: { _eq: $role } }) {\n      user_role_relations(where: { branch_id: { _eq: $branch_id } }) {\n        user {\n          id\n          first_name\n          last_name\n          nick_name\n        }\n      }\n    }\n  }\n"])));
export var UsersWithRolesQuery = gql(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  query UsersWithRolesQuery($branch_id: bigint, $roles: [String!]) {\n    roles(where: { name: { _in: $roles } }) {\n      name\n      user_role_relations(where: { branch_id: { _eq: $branch_id } }) {\n        user {\n          id\n          first_name\n          last_name\n          nick_name\n        }\n      }\n    }\n  }\n"])));
export var getUsers = R.pipe(R.pathOr([], ['roles']), R.chain(R.prop('user_role_relations')), R.chain(R.prop('user')), R.uniqBy(R.prop('id')));
export var useUserByRole = function useUserByRole(role, branch_id) {
  var _useQuery = useQuery(UsersWithRoleQuery, {
    variables: {
      branch_id: branch_id || BranchConstants.BRANCH_ID,
      role: role
    }
  }),
      data = _useQuery.data,
      rest = _objectWithoutProperties(_useQuery, _excluded);

  var result = useMemo(function () {
    return data ? getUsers(data) : [];
  }, [data]);
  return _objectSpread({
    data: result
  }, rest);
};
export var useUserByRoles = function useUserByRoles(roles, branch_id) {
  var _useQuery2 = useQuery(UsersWithRolesQuery, {
    variables: {
      branch_id: branch_id || BranchConstants.BRANCH_ID,
      roles: roles
    },
    skip: !roles.length
  }),
      data = _useQuery2.data,
      rest = _objectWithoutProperties(_useQuery2, _excluded2);

  var result = useMemo(function () {
    if (!data) {
      return {};
    }

    return R.pipe(R.propOr([], 'roles'), R.chain(function (role) {
      return R.pipe(R.propOr([], 'user_role_relations'), R.map(function (relation) {
        return R.mergeRight(relation.user, {
          role: role.name
        });
      }))(role);
    }), R.groupBy(R.prop('role')), R.mapObjIndexed(R.uniqBy(R.prop('id'))))(data);
  }, [data]);
  return _objectSpread({
    data: result
  }, rest);
}; // 銷售帳號清單

export var useSalesList = function useSalesList() {
  var _useUserByRole = useUserByRole(RoleType.CLINIC_DIETICIAN_ROLE),
      dieticians = _useUserByRole.data;

  var _useUserByRole2 = useUserByRole(RoleType.CLINIC_SALESPERSON_ROLE),
      salespeople = _useUserByRole2.data;

  var sales = useMemo(function () {
    return R.pipe(R.concat(salespeople), R.uniqBy(R.prop('id')))(dieticians);
  }, [dieticians, salespeople]);
  return sales;
};